

<div class="container-fluid welcome-container min-vh-100">
        <div class="row justify-content-center">
            <div class="col-12 col-xl-10">
                <!-- Page Title -->
                <div class="text-center py-5 text-decoration-underline">
                    <h1 class="page-title">Assignment Page</h1>
                </div>

                <div class="text-left py-5 ">
                     <label for="assignmentId" class="me-2 bg-whitetext-dark fw-medium">Assignment Name:</label>
                    <input type="text" id="assignmentId" placeholder="Enter assignment name..." [(ngModel)]="assignmentName" class="border-0 rounded-1 ps-2" />

                    <label for="time" class="me-2 bg-whitetext-dark fw-medium ps-4">Time in Minutes:</label>
                    <input type="number" id="time" placeholder="Enter time in Minutes..." [(ngModel)]="time" class="border-0 rounded-1" />
                </div>

                        <!-- Assignment Form -->
                    <div class="assignment-container align-items-center">
                    <div class="row g-4 mb-4">

                        <!-- Select Team -->
                         <div class="col-md-4">    
  <label class="form-label form-label-custom fw-normal  mb-3 d-block">
    <i class="fas fa-users me-2"></i>
    Select Team
  </label>

  <div class="position-relative dropdown">
    <div
      class="bg-white border rounded-3 p-3 d-flex justify-content-between align-items-center"
      style="cursor: pointer;"
      data-bs-toggle="dropdown"
      data-bs-display="static"   
      data-bs-flip="false"
      aria-expanded="false"
    >
      <div class="d-flex align-items-center">
      <img src="assets/images/Vector.png" alt="Team Icon" width="16" height="12" class="me-3" />
      <span class="text-muted">
          <ng-container *ngIf="selectedTeam; else placeholder">
            <ng-container *ngFor="let team of teams">
              <ng-container *ngIf="team.teamId === selectedTeam">
                {{ team.name }}
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-template #placeholder>Assign task to team</ng-template>
        </span> 
    </div>
      
       <img src="assets/images/down.jpg" alt="Team Icon" width="20" height="20" class="ms-2" />
    </div>

    <ul class="dropdown-menu w-100 mt-1 shadow-sm border-0 overflow-auto" style="max-height: 300px;">
      <li
        *ngFor="let team of teams"
        class="dropdown-item d-flex justify-content-between align-items-center mb-2 py-2 "
        style="cursor: pointer;"
        (click)="selectedTeam = team.teamId; onTeamChange()"
      >
        <span class="text-poppins-13">{{ team.name }}</span>
       <span class="text-muted font-poppins text-12">{{ team.users.length }} members</span>

      </li>
    </ul>
  </div>
</div>


                        <!-- Select User -->
                        <div class="col-md-4">
                            <label class="form-label form-label-custom fw-normal mb-3 d-block">
                                <i class="fas fa-user me-2"></i>
                                Select User
                            </label>
                            <div class="custom-dropdown position-relative">
                                <div class="dropdown-toggle-custom bg-white border  rounded-3 p-3 d-flex justify-content-between align-items-center"
                                style="cursor: pointer; min-height: 48px; transition: all 0.2s ease;" (click)="toggleDropdown('user'); $event.stopPropagation()">
                                     <img src="assets/images/Vector.png" alt="Assignment Icon" width="16" height="12" class="me-3" />
                                    <span class="text-muted w-100">Assign task to user {{ selectedTeamName }}</span>

                                    <div class="d-flex align-items-center">
                                         
       <img src="assets/images/down.jpg" alt="Team Icon" width="20" height="20" class="ms-2" />

                                    </div>
                                </div>
                                <div class="dropdown-menu-custom bg-white text-dark  mt-3  rounded-3 shadow-sm border-0" 
                                    [class.show]="userDropdownOpen"
                                    *ngIf="selectedTeam"
                                    (click)="onDropdownClick($event)">
                                    
                                    
                                     <div class="d-flex justify-content-center">
                                    <input type="text" 
                                        class="form-control search-input rounded-pill text-start px-4 py-1 mt-2 w-75" 
                                        style="background-color: #F4F7FC; border: none; font-size: 0.95rem; box-shadow: none; " 
                                        placeholder="Search" 
                                        [(ngModel)]="userSearchTerm"></div>

                                    
                                    <div class="dropdown-item-custom p-3 d-flex align-items-center gap-3" 
                                     style="cursor:pointer; transition: background-color 0.2s ease;"
                                     onmouseover="this.classList.add('bg-light')"
                                     onmouseout="this.classList.remove('bg-light')" 
                                        (click)="toggleSelectAllUsers()">
                                        <input type="checkbox" style="transform: scale(1.1);"
                                            [checked]="areAllUsersSelected"
                                            [indeterminate]="selectedUsers.length > 0 && !areAllUsersSelected">
                                        <span><strong>Select All</strong></span>
                                    </div>
                                    
                                    <div class="dropdown-item-custom p-3 d-flex align-items-center gap-3 border border-light hover-highlight rounded-2" 
                                     style="cursor: pointer; transition: background-color 0.2s ease;"
                                     onmouseover="this.classList.add('bg-light')"
                                     onmouseout="this.classList.remove('bg-light')" 
                                        *ngFor="let user of searchFilteredUsers"
                                        (click)="toggleUser(user)">
                                        <input type="checkbox"  style="transform: scale(1.1);"
                                            [checked]="isUserSelected(user)">
                                        <span>{{ user.Name }}</span>
                                    </div>
                                    
                                    <div *ngIf="searchFilteredUsers.length === 0" class="dropdown-item-custom text-muted">
                                        No users found
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Select Assignment w-100 border-0 border-bottom p-2 -->
                         <div class="col-md-4">
                            <label class="form-label form-label-custom fw-normal mb-3 d-block">
                                <i class="fas fa-file-alt me-2"></i>
                                Select Assignment
                            </label> 
                            <div class="custom-dropdown position-relative">
                                <div class="dropdown-toggle-custom bg-white border  rounded-3 p-3 d-flex justify-content-between align-items-center" 
                                 style="cursor: pointer; min-height: 48px; transition: all 0.2s ease;" (click)="toggleDropdown('assignment'); $event.stopPropagation()">
                                    <img src="assets/images/letter.png" alt="Assignment Icon" width="20" height="20" class="me-3" />
                                  
                                    <span class="text-muted  w-100">Select assignment</span>

                                    <div class="d-flex align-items-center">
                                        
                                           
       <img src="assets/images/down.jpg" alt="Team Icon" width="20" height="20" class="ms-2" />
                                       

                                    </div>
                                </div>
                                <div class="dropdown-menu-custom bg-white mt-3 text-dark  rounded-3 shadow-sm border-0" 
                                    [class.show]="assignmentDropdownOpen"
                                    *ngIf="selectedTeam"
                                    (click)="onDropdownClick($event)">

                                    <div class="d-flex justify-content-center">
                                    <input type="text" 
                                        class="form-control search-input rounded-pill text-start px-4 py-1 mt-2 w-75" 
                                        style="background-color: #F4F7FC; border: none; font-size: 0.95rem; box-shadow: none; " 
                                        placeholder="Search" 
                                        [(ngModel)]="assignmentSearchTerm"></div>
                                    
                                    <div class="dropdown-item-custom p-3 d-flex align-items-center gap-3" 
                                     style="cursor: pointer; transition: background-color 0.2s ease;" 
                                        (click)="toggleSelectAllAssignments()">
                                        <input type="checkbox" style="transform: scale(1.1);"
                                            [checked]="areAllAssignmentsSelected"
                                            [indeterminate]="selectedAssignments.length > 0 && !areAllAssignmentsSelected">
                                        <span><strong>Select All</strong></span>
                                    </div>
                                    
                                    <div class="dropdown-item-custom p-3 d-flex align-items-center gap-3"
                                     style="cursor: pointer; transition: background-color 0.2s ease;"
                                     onmouseover="this.classList.add('bg-light')"
                                     onmouseout="this.classList.remove('bg-light')" 
                                        *ngFor="let assignment of searchFilteredAssignments"
                                        (click)="toggleAssignment(assignment)">
                                        <input type="checkbox"
                                            [checked]="isAssignmentSelected(assignment)">
                                        <span>{{ assignment.name }}</span>
                                    </div>
                                    
                                    <div *ngIf="searchFilteredAssignments.length === 0" class="dropdown-item-custom text-muted">
                                        No assignments found
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Assign Button -->
                    <div class="text-center mt-5 mb-3">
                        <button (click)="assignTagToUser()" 
                                class="btn btn-primary px-5 py-1.5 rounded-5 fw-medium"
                                [disabled]="selectedUsers.length === 0 || selectedAssignments.length === 0">
                            <i class="fas fa-plus "></i>
                            Assign
                        </button>
                    </div>

                    <!-- Table Data -->
                  
                        <div class="container mt-5" *ngIf="showAssignmentTable"#assignmentTable >
                        <div class="table-wrapper bg-white mt-2 rounded bg-white rounded-3 overflow-hidden shadow-sm">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th class="bg-light border-bottom border-2 fw-semibold text-color p-4">Name</th>
                                        <th class="bg-light border-bottom border-2 fw-semibold text-color p-4">Assignments</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let userAssignment of userAssignments; trackBy: trackByUserId">
                                        <td class="p-4 align-middle">{{ userAssignment.user.Name }}</td>
                                        <td>
                                            <span class="tag-item d-inline-flex align-items-center rounded-pill px-3 py-2 m-1 small fw-medium border" 
                                                *ngFor="let assignment of userAssignment.tags; trackBy: trackByAssignmentId">
                                                {{ assignment.name }}
                                                <button class="remove-tag-btn btn btn-sm border-0 bg-transparent p-0 ms-2 rounded-circle d-flex align-items-center justify-content-center text-primary" 
                                            style="width: 20px; height: 20px; font-size: 1.2rem; cursor: pointer; transition: all 0.2s ease;"
                                            onmouseover="this.classList.add('bg-primary', 'text-white')"
                                            onmouseout="this.classList.remove('bg-primary', 'text-white')" 
                                                        (click)="removeAssignment(userAssignment, assignment)"
                                                        title="Remove assignment">
                                                    ×
                                                </button>
                                            </span>
                                            <span *ngIf="userAssignment?.tags?.length === 0" class="text-muted">
                                                No assignments
                                            </span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="userAssignments.length === 0">
                                        <td colspan="2" class="text-center text-muted">
                                            No assignments made yet
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>


                        <div class="add-container my-3 d-flex justify-content-center">
    <button class="btn btn-primary px-5 py-1.5 rounded-5 fw-medium" (click)="addTagsToUser()">
                                Submit
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
                </div> 
